// GENERATED by scripts/generate-image-sizes.mjs — do not edit by hand.
// Intrinsic width and height per screenshot, so a content image reserves its space before it loads.

export const IMAGE_SIZES: Record<string, readonly [number, number]> = {
    '/assets/screenshots/ai-assistant-chat.webp': [1400, 888],
    '/assets/screenshots/attendee-export.webp': [1400, 1534],
    '/assets/screenshots/badges-catalog.webp': [562, 1170],
    '/assets/screenshots/bga-play.webp': [1170, 1236],
    '/assets/screenshots/bgg-export.webp': [1328, 906],
    '/assets/screenshots/campaign-sessions.webp': [1400, 1136],
    '/assets/screenshots/campaigns-campaign-page.webp': [1400, 1812],
    '/assets/screenshots/campaigns-member-menu.webp': [1488, 660],
    '/assets/screenshots/campaigns-members.webp': [845, 805],
    '/assets/screenshots/club-copy-lent.webp': [800, 480],
    '/assets/screenshots/collection-filters.webp': [920, 1040],
    '/assets/screenshots/collection-game-detail.webp': [1400, 1400],
    '/assets/screenshots/collection-game-page.webp': [1396, 1573],
    '/assets/screenshots/collection-grid-cropped.webp': [1170, 1809],
    '/assets/screenshots/collection-grid.webp': [1170, 1152],
    '/assets/screenshots/collection-inventory.webp': [2560, 1800],
    '/assets/screenshots/collection-list-view.webp': [1520, 1120],
    '/assets/screenshots/collection-ownership-chips.webp': [1170, 1350],
    '/assets/screenshots/collection-sort.webp': [960, 1360],
    '/assets/screenshots/console-announcements.webp': [2014, 1342],
    '/assets/screenshots/console-dashboard.webp': [2560, 1800],
    '/assets/screenshots/console-members.webp': [2560, 1800],
    '/assets/screenshots/console-permissions.webp': [1828, 1608],
    '/assets/screenshots/console-tiers.webp': [1868, 1182],
    '/assets/screenshots/creator-content-game-page.webp': [1464, 1580],
    '/assets/screenshots/embed-collection.webp': [2560, 1674],
    '/assets/screenshots/event-fills-itself.webp': [840, 735],
    '/assets/screenshots/event-ops-custom-form.webp': [498, 716],
    '/assets/screenshots/event-ops-floor-plan.webp': [1400, 876],
    '/assets/screenshots/event-ops-qr-checkin.webp': [1170, 2532],
    '/assets/screenshots/events-create-form.webp': [2384, 2010],
    '/assets/screenshots/events-dashboard-widget.webp': [1376, 602],
    '/assets/screenshots/events-discovery.webp': [1170, 1908],
    '/assets/screenshots/events-event-page.webp': [1400, 1800],
    '/assets/screenshots/events-games.webp': [1170, 2400],
    '/assets/screenshots/events-map-cropped.webp': [1368, 1378],
    '/assets/screenshots/events-map-view.webp': [1400, 1576],
    '/assets/screenshots/events-raffle-prizes.webp': [1170, 1752],
    '/assets/screenshots/events-schedule-cropped.webp': [1400, 982],
    '/assets/screenshots/events-schedule-lineup.webp': [1400, 1800],
    '/assets/screenshots/events-tournament-standings.webp': [1400, 762],
    '/assets/screenshots/explore-communities.webp': [1400, 1152],
    '/assets/screenshots/explore-events.webp': [1170, 1908],
    '/assets/screenshots/explore-filters.webp': [664, 1620],
    '/assets/screenshots/explore-game-filters.webp': [1400, 920],
    '/assets/screenshots/explore-games.webp': [1400, 1720],
    '/assets/screenshots/explore-people.webp': [1170, 1785],
    '/assets/screenshots/first-steps-dashboard.webp': [1396, 1716],
    '/assets/screenshots/first-steps-start-play.webp': [1170, 1188],
    '/assets/screenshots/game-community-stats.webp': [832, 1352],
    '/assets/screenshots/game-copy-borrowed.webp': [950, 950],
    '/assets/screenshots/game-copy-labels.webp': [1411, 1061],
    '/assets/screenshots/game-copy-scan.webp': [950, 1010],
    '/assets/screenshots/game-kits-editor.webp': [1120, 1800],
    '/assets/screenshots/game-kits-kit-page.webp': [1400, 1516],
    '/assets/screenshots/game-kits-pro-mode.webp': [1120, 2160],
    '/assets/screenshots/game-kits-score-sheet.webp': [1400, 1686],
    '/assets/screenshots/game-kits-setup-steps.webp': [1170, 2025],
    '/assets/screenshots/game-page-header.webp': [1400, 1044],
    '/assets/screenshots/game-page-my-info-widget.webp': [402, 249],
    '/assets/screenshots/game-page-similar-games.webp': [1400, 512],
    '/assets/screenshots/group-page-cropped.webp': [1400, 1806],
    '/assets/screenshots/group-page.webp': [2560, 1940],
    '/assets/screenshots/group-stats.webp': [1400, 1468],
    '/assets/screenshots/groups-collective-collection.webp': [677, 806],
    '/assets/screenshots/groups-invite-dialog.webp': [560, 802],
    '/assets/screenshots/groups-manage-member.webp': [1024, 1088],
    '/assets/screenshots/groups-members-list.webp': [2036, 1440],
    '/assets/screenshots/groups-new-community-dialog.webp': [960, 1100],
    '/assets/screenshots/home-gallery-collection.webp': [860, 1433],
    '/assets/screenshots/home-gallery-event.webp': [840, 1400],
    '/assets/screenshots/home-gallery-play.webp': [1170, 2100],
    '/assets/screenshots/home-phone-profile.webp': [1179, 2334],
    '/assets/screenshots/home-replay-biggest-day.webp': [2560, 1720],
    '/assets/screenshots/import-wizard-review.webp': [1280, 1292],
    '/assets/screenshots/integrations-bga.webp': [1400, 920],
    '/assets/screenshots/integrations-bgg.webp': [1400, 1300],
    '/assets/screenshots/live-sessions-lifecycle.webp': [3360, 1508],
    '/assets/screenshots/live-sessions-player-order.webp': [1100, 882],
    '/assets/screenshots/live-sessions-score-sheet.webp': [1400, 1352],
    '/assets/screenshots/live-sessions-timers.webp': [355, 395],
    '/assets/screenshots/locations-edit-dialog.webp': [1120, 808],
    '/assets/screenshots/locations-list.webp': [1170, 1068],
    '/assets/screenshots/market-consignment.webp': [2700, 1896],
    '/assets/screenshots/marketplace-browse.webp': [1400, 1692],
    '/assets/screenshots/marketplace-create-listing.webp': [1000, 2268],
    '/assets/screenshots/marketplace-filters.webp': [600, 1082],
    '/assets/screenshots/marketplace-list.webp': [1170, 1902],
    '/assets/screenshots/marketplace-listing-detail.webp': [1170, 1860],
    '/assets/screenshots/messaging-event-chat.webp': [1888, 1800],
    '/assets/screenshots/messaging-group-chat.webp': [1888, 1800],
    '/assets/screenshots/messaging.webp': [840, 1335],
    '/assets/screenshots/notifications-list.webp': [1170, 2355],
    '/assets/screenshots/notifications-settings.webp': [1170, 2175],
    '/assets/screenshots/offline-mode.webp': [1400, 848],
    '/assets/screenshots/onboarding-account-type.webp': [960, 880],
    '/assets/screenshots/onboarding-org-setup.webp': [960, 1130],
    '/assets/screenshots/organizations-profile.webp': [1170, 2292],
    '/assets/screenshots/play-booth-schedule.webp': [1400, 1118],
    '/assets/screenshots/play-booth.webp': [1400, 1346],
    '/assets/screenshots/play-logging-calendar-view.webp': [1400, 1684],
    '/assets/screenshots/play-logging-grid-view.webp': [1396, 1556],
    '/assets/screenshots/play-logging-log-dialog.webp': [1170, 1890],
    '/assets/screenshots/play-logging-monthly-summary.webp': [1000, 1000],
    '/assets/screenshots/play-logging-play-page.webp': [1400, 1244],
    '/assets/screenshots/players-saved-list.webp': [1170, 1800],
    '/assets/screenshots/plays-list.webp': [920, 1200],
    '/assets/screenshots/prices-view.webp': [836, 1208],
    '/assets/screenshots/privacy-block-menu.webp': [1170, 1260],
    '/assets/screenshots/privacy-settings.webp': [1391, 1378],
    '/assets/screenshots/public-api-console.webp': [1464, 1308],
    '/assets/screenshots/public-api-key.webp': [828, 648],
    '/assets/screenshots/public-api-page.webp': [1400, 1640],
    '/assets/screenshots/public-api-signin.webp': [1400, 1280],
    '/assets/screenshots/replay-badges-page.webp': [1400, 1496],
    '/assets/screenshots/replay-carousel.webp': [2560, 1720],
    '/assets/screenshots/reviews-community-averages.webp': [1400, 238],
    '/assets/screenshots/reviews-game-reviews.webp': [1400, 1280],
    '/assets/screenshots/reviews-profile-list.webp': [1400, 1280],
    '/assets/screenshots/reviews-write-form.webp': [960, 1280],
    '/assets/screenshots/scheduled-games-page.webp': [1170, 1776],
    '/assets/screenshots/scheduled-games-participants.webp': [1170, 1533],
    '/assets/screenshots/settings-language.webp': [1395, 805],
    '/assets/screenshots/shelf-planner.webp': [1024, 831],
    '/assets/screenshots/shelves-arrange.webp': [700, 720],
    '/assets/screenshots/shops-feed-deals.webp': [1400, 1040],
    '/assets/screenshots/shops-game-prices.webp': [1386, 850],
    '/assets/screenshots/shops-marketplace-section.webp': [848, 930],
    '/assets/screenshots/social-feed-translated.webp': [1400, 740],
    '/assets/screenshots/social-feeds-following.webp': [1170, 2112],
    '/assets/screenshots/social-feeds-global.webp': [864, 870],
    '/assets/screenshots/sponsored-badge.webp': [624, 726],
    '/assets/screenshots/stand-desk.webp': [1400, 1237],
    '/assets/screenshots/stand-timetable.webp': [780, 1200],
    '/assets/screenshots/statistics-distribution-donuts.webp': [1400, 402],
    '/assets/screenshots/statistics-game-community-stats.webp': [1391, 1290],
    '/assets/screenshots/statistics-game-personal-stats.webp': [1400, 1676],
    '/assets/screenshots/statistics-head-to-head.webp': [1400, 1198],
    '/assets/screenshots/statistics-most-played.webp': [1370, 595],
    '/assets/screenshots/statistics-user-stats.webp': [1370, 400],
    '/assets/screenshots/statistics-weekday-collection.webp': [1370, 430],
    '/assets/screenshots/stats-page-full.webp': [1400, 3070],
    '/assets/screenshots/stats-page.webp': [1400, 1616],
    '/assets/screenshots/table-bookings-book.webp': [1170, 2385],
    '/assets/screenshots/table-bookings-desk.webp': [1400, 875],
    '/assets/screenshots/telegram-channel-post.webp': [940, 1480],
    '/assets/screenshots/telegram-settings.webp': [816, 1088],
    '/assets/screenshots/ticketing-buyer-sheet.webp': [920, 1440],
    '/assets/screenshots/ticketing-connect-stripe.webp': [1000, 390],
    '/assets/screenshots/ticketing-sales-panel.webp': [1400, 1224],
    '/assets/screenshots/ticketing-types-editor.webp': [1040, 1246],
    '/assets/screenshots/tournament-bracket.webp': [1566, 812],
    '/assets/screenshots/tournament-event.webp': [1364, 1366],
    '/assets/screenshots/tournament-mixer-schedule.webp': [1400, 850],
    '/assets/screenshots/tournament-phases.webp': [1400, 916],
    '/assets/screenshots/tournament-standings.webp': [1400, 1414],
    '/assets/screenshots/tournament-table-reporting.webp': [1704, 1176],
    '/assets/screenshots/user-profiles-cover.webp': [1170, 990],
    '/assets/screenshots/user-profiles-header.webp': [1088, 1664],
    '/assets/screenshots/user-profiles-layout-editor.webp': [1400, 1668],
    '/assets/screenshots/user-profiles-profile.webp': [1488, 595],
    '/assets/screenshots/user-profiles-widgets.webp': [1488, 900],
    '/assets/screenshots/venue-profile.webp': [1400, 1472],
    '/assets/premium/ai-assistant.png': [698, 417],
    '/assets/premium/attendance-forms.png': [472, 305],
    '/assets/premium/attendee-export.png': [860, 702],
    '/assets/premium/auto-cancel.png': [1200, 689],
    '/assets/premium/auto-open-close.png': [748, 612],
    '/assets/premium/availability-heatmap.png': [697, 355],
    '/assets/premium/boosted-marketplace.png': [569, 272],
    '/assets/premium/campaigns.png': [690, 447],
    '/assets/premium/club-insights.png': [1200, 792],
    '/assets/premium/co-hosted-events.png': [796, 616],
    '/assets/premium/event-display.png': [1298, 421],
    '/assets/premium/event-game-library.png': [1200, 761],
    '/assets/premium/every-location.png': [1200, 1122],
    '/assets/premium/game-changes.png': [490, 374],
    '/assets/premium/game-lending.png': [600, 342],
    '/assets/premium/lending-desk.png': [1200, 888],
    '/assets/premium/ludoya-tickets.png': [1107, 1200],
    '/assets/premium/membership-tiers.png': [1200, 600],
    '/assets/premium/premium-badge.png': [482, 222],
    '/assets/premium/public-api.png': [845, 337],
    '/assets/premium/qr-attendance.png': [353, 196],
    '/assets/premium/raffles.png': [860, 540],
    '/assets/premium/raised-api-limits.png': [1200, 720],
    '/assets/premium/recurring-events.png': [656, 366],
    '/assets/premium/shared-inbox.png': [1200, 738],
    '/assets/premium/sub-events.png': [703, 504],
    '/assets/premium/table-bookings.png': [703, 651],
    '/assets/premium/telegram-integration.png': [1109, 704],
    '/assets/premium/tournaments.png': [696, 393],
    '/assets/premium/unlimited-form-questions.png': [1120, 790],
    '/assets/premium/venue-settings.png': [522, 325],
    '/assets/premium/visibility.png': [696, 450],
};
